export default __webpack_public_path__ + "static/media/38.ec68a904.png";